// extracted by mini-css-extract-plugin
export default {"ScreenXSMax":"(max-width: 767px)","container":"Ga7335a Gcf189c"};